// /client/src/components/DesignNextMoveGoal.js
import React from 'react';
import NavigationPdfs from './NavigationPdfs';
import FooterPdfs from './FooterPdfs';

const DesignNextMoveGoal = () => {
  return (
    <>
      <div className="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between">
        <div className='fullWidth'>
            <NavigationPdfs />
            <div className="pt-2 columns is-centered">
                <div className="column is-6-tablet is-5-desktop is-5-widescreen">
                    <div className="px-4 py-5">
                        <h1 className="h1 colorBlack is-bold">Design a Next Move Goal</h1>
                        <h2 className='h2 is-bold'>Introduction</h2>
                        <p className="pb-4 colorBlack">
                            A Next Move Goal is one that is rightsized, specific, and connected to a visually-inspiring image. Designing a goal in this manner helps you stay focused, gain momentum, and increase the likelihood of being successful.
                        </p>
                        <p className="pb-4 colorBlack">
                            Click the download button below to view the optional reading. 
                        </p>
                        <div className="py-5 field">
                            <a 
                                href="/pdfs/next-move-design-a-next-move-goal.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button"
                                download
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <FooterPdfs />
      </div>
    </>
  );
};

export default DesignNextMoveGoal;